<script setup lang="ts">
import type { DialogController } from "@/vf"
import { computed, h, isVNode, type VNode } from "vue"

const props = defineProps<{
    controller: DialogController<void, { message: string | VNode }>
}>()
const options = computed(() => props.controller.props)

const message = computed(() => {
    if (isVNode(options.value.message)) {
        return options.value.message
    }

    return h("p", null, options.value.message)
})
</script>

<template>
    <div class="dialog-body text-center py-5">
        <div class="fa fa-fw fa-circle-notch fa-spin fa-2x mb-5"></div>
        <component :is="message"></component>
    </div>
</template>
